export default "__VITE_ASSET__CaC_m5aD__"